import React from 'react';
import styled from 'styled-components';
import { Reviews } from 'au-gatsby-ds/components';
import { StarProps } from 'components/Yotpo/helpers';
import { mediaQuery, mediaQueryMax } from 'components/Grid';
import { Rating } from '../../../types/Product';

interface Props {
  stars: React.FunctionComponentElement<StarProps>[];
  rating: Rating;
  handleClick: React.MouseEventHandler<HTMLAnchorElement>;
}

export const YotpoStarsNewUI: React.FC<Props> = ({ handleClick, stars, rating }) => (
  <Container className="yotpo new-design">
    <a href="#yotpo-reviews-anchor" onClick={handleClick}>
      <div className="standalone-bottomline">
        <div className="yotpo-bottomline pull-left star-clickable">
          <span className="yotpo-stars">{stars}</span>
          <span className="rating">{rating.score.toFixed(1)}</span>
          <span className="reviews">({rating.totalReviews} REVIEWS)</span>
        </div>
      </div>
    </a>
  </Container>
);

const Container = styled.div`
  margin: 12px 0 20px 0;

  ${mediaQuery.medium`
    margin: 0;
  `}
  ${mediaQueryMax.medium`
    margin: 2px 0 20px 0;
  `}
  &.yotpo.new-design span {
    ${props => Reviews}
  }

  &.yotpo.new-design {
    a:hover .yotpo-bottomline {
      .rating-star,
      .yotpo-icon-star,
      .rating,
      .reviews {
        color: #646464;
      }
    }

    .yotpo-bottomline {
      height: 20px;
      display: flex;
      gap: 8px;
      align-items: center;

      .yotpo-stars {
        .rating-star {
          margin: 0 2px;
          font-size: 16px;
        }
      }

      .rating, .reviews {
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        font-weight: 600;
      }

      .reviews {
        letter-spacing: 1.4px;
      }

      .yotpo-icon-star {
        color: #000000;
      }

      .yotpo-icon-half-star:after {
        content: '\\e61a';
        position: absolute;
        left: 0;
        top: 0;
        color: #000000;
        width: 48%;
        overflow: hidden;
      }
    }

    .yotpo-regular-box {
      padding: 0;
      margin: 0;
      border: none;
    }

    .yotpo-small-box,
    .yotpo-first-review,
    .yotpo-review,
    .yotpo-pager {
      display: none;
    }
  }

  .write-review-btn-hidden {
    display: none;
  }
`;
